<template>
	<component :is="parent" :href="$path(item, 'slug')" :content="item" class="card a-none-deco">
		<div class="card__cover" :class="{ 'card__cover--hover': showHoverState }" :style="cssVars">
			<img :src="item.url" :alt="item.slug" width="540" height="548" :style="style" />
		</div>
		<slot />
	</component>
</template>

<script>
export default {
	props: {
		item: {
			type: Object,
			default: () => ({}),
		},
		showHoverState: {
			type: Boolean,
			default: true,
		},
		coverHeight: {
			type: String,
			default: '300px',
		},
		responsiveCoverHeight: {
			type: String,
			default: '300px',
		},
	},
	computed: {
		parent() {
			if (!this.$path(this.item, 'slug')) return 'div'
			return 'a'
		},
		style() {
			let focalPoint = this.$path(this.item, 'focalPoint')

			return `objectPosition: ${focalPoint.x * 100}% ${focalPoint.y * 100}%;`
		},

		cssVars() {
			return {
				'--cover-height': this.coverHeight,
				'--resposive-cover-height': this.responsiveCoverHeight,
			}
		},
	},

	methods: {},
}
</script>

<style lang="scss">
@import '@/styles/base/_variables.scss';
@import '@/styles/utils/_mixins.scss';

.card {
	&__cover {
		position: relative;
		margin: auto;
		overflow: hidden;
		width: inherit;

		img {
			max-width: 100%;
			transition: transform 0.5s ease-out;
			display: block;
			width: 100%;
			object-fit: cover;
			height: var(--cover-height);
			transform: scale(1);
			@include respond-below('phone') {
				height: var(--resposive-cover-height);
			}
		}

		&--hover {
			img {
				&:hover {
					transform: scale(1.05);
				}
			}
		}
	}
}
</style>
